function setItemOnStorage(key, value) {
  window.sessionStorage.setItem(key, value);
}

function retrieveItemFromStorage(key) {
  const data = window.sessionStorage.getItem(key);
  return JSON.parse(data);
}

function getStorefrontConfig() {
  const configElement = document.getElementById("storefront-api-config");
  if (!configElement) return {};

  try {
    const config = JSON.parse(configElement.textContent);
    return {
      token: config.token,
      domain: config.domain,
      version: config.version || "2024-04",
    };
  } catch (error) {
    return {};
  }
}

const SWATCH_PRODUCT_QUERY = `
  query SwatchProduct($handle: String!) {
    product(handle: $handle) {
      images(first: 4) { nodes { url } }
      priceRange { minVariantPrice { amount } }
      compareAtPriceRange { minVariantPrice { amount } }
    }
  }
`;

function swatchCacheKey(handle) {
  return `swatch:v2:${handle}`;
}

function toCents(amount) {
  return Math.round(parseFloat(amount || 0) * 100);
}

async function fetchProductData(productHandle) {
  const cacheKey = swatchCacheKey(productHandle);
  const cached = retrieveItemFromStorage(cacheKey);
  if (!!cached) return cached;

  const { token, domain, version } = getStorefrontConfig();
  if (!token || !domain) {
    console.warn("product-swatch: Storefront API config missing; cannot load", productHandle);
    return null;
  }

  try {
    const response = await fetch(`https://${domain}/api/${version}/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": token,
      },
      body: JSON.stringify({
        query: SWATCH_PRODUCT_QUERY,
        variables: { handle: productHandle },
      }),
    });

    const json = await response.json();
    const product = json && json.data && json.data.product;
    if (!product) return null;

    const productData = {
      images: (product.images && product.images.nodes || []).map((node) => node.url),
      price: toCents(product.priceRange && product.priceRange.minVariantPrice && product.priceRange.minVariantPrice.amount),
      compare_at_price: toCents(product.compareAtPriceRange && product.compareAtPriceRange.minVariantPrice && product.compareAtPriceRange.minVariantPrice.amount),
    };

    setItemOnStorage(cacheKey, JSON.stringify(productData));
    return productData;
  } catch (error) {
    console.error("product-swatch: Storefront API request failed for", productHandle, error);
    return null;
  }
}

function updateProductImages(imageWrappers, newImages) {
  imageWrappers.forEach(function(element, index) {
    const image = element.querySelector("img");
    image.src = newImages[index];
    image.removeAttribute("srcset");
    image.removeAttribute("data-srcset");
  });

  const imageContainer = imageWrappers[0].closest('.product-item__link');
  if (imageWrappers.length > 1 && !imageContainer.classList.contains("has-second-image")) {
    imageContainer.classList.add("has-second-image")
  }
  if (imageWrappers.length == 1 && imageContainer.classList.contains("has-second-image")) {
    imageContainer.classList.remove("has-second-image");
  }
}

function handlePriceFormat(price) {
  return (price / 100).toLocaleString(undefined, {
    style: 'currency',
    currency: Shopify.currency.active,
    minimumFractionDigits: 2
  });
}

function handlePriceSwap(priceElement, productData) {
  const { compare_at_price, price } = productData;

  // If compare_at_price is 0, a product is not on sale
  if (compare_at_price == 0) {
    const productPrice = handlePriceFormat(price);
    const priceSpan = document.createElement("span");
    priceSpan.textContent = productPrice;
    priceElement.replaceChildren(priceSpan);
    return;
  }

  // If compare at price is not zero and more than price, a product is on sale
  if (compare_at_price > 0 && compare_at_price > price) {
    const salePrice = handlePriceFormat(price);
    const originalPrice = handlePriceFormat(compare_at_price);

    const salePriceSpan = document.createElement("span");
    salePriceSpan.classList.add("sale");
    salePriceSpan.textContent = `${salePrice} `;

    const regularPriceSpan = document.createElement("span");
    regularPriceSpan.classList.add("regular", "regular--has-sale");
    regularPriceSpan.textContent = originalPrice;

    priceElement.replaceChildren(salePriceSpan, regularPriceSpan);
    return;
  }
} 

export function initProductSwatches() {
  const productSwatches = document.querySelectorAll(".product-item__swatch");
  if (!productSwatches) return;

  productSwatches.forEach(function(swatch) {
    swatch.addEventListener("click", async function() {
      const { productHandle } = this.dataset;

      const productData = await fetchProductData(productHandle);
      if (!productData) return;
  
      const productCard = swatch.closest(".product-item");
      if (!productCard) return;

      const imageElements = productCard.querySelectorAll(".product-item__img");
      if (!!imageElements?.length && !!productData?.images?.length) {
        updateProductImages(imageElements, productData.images)
      }

      const currentMarket = Shopify?.routes?.root ?? "/";
      const productUrl = `${currentMarket}products/${productHandle}`;
      productCard.querySelector(".product-item__link").href = productUrl;
      productCard.querySelector(".product-item__swatch.is-active").classList.remove("is-active");
      swatch.classList.add("is-active");

      const priceElement = productCard.querySelector(".product-item__price");
      handlePriceSwap(priceElement, productData);
    })
  });
}

initProductSwatches();